// extracted by mini-css-extract-plugin
module.exports = {"root":"upload-dropzone_root__HSTwq","msg":"upload-dropzone_msg__xqSOm"};